/**
 * User status → first-login onboarding path.
 * 9 / 0 = must complete create-profile
 * 8 = must complete desired-partner
 * 3 = pending admin approval (currently auto-active while approval is disabled)
 * 1 = fully active / approved
 */
export function getUserStatus(userData) {
  if (userData == null) return null;
  const raw = typeof userData === 'object' ? userData.status : userData;
  if (raw === null || raw === undefined || raw === '') return null;
  const n = Number(raw);
  return Number.isNaN(n) ? null : n;
}

export function getOnboardingPath(status) {
  const s = getUserStatus(status);
  if (s === 9 || s === 0) return '/create-profile';
  if (s === 8) return '/desired-partner';
  // Pending approval removed for now; treat 1 and 3 as fully onboarded
  if (s === 1 || s === 3) return null;
  return null;
}

export function isFullyOnboarded(status) {
  const s = getUserStatus(status);
  return s === 1 || s === 3;
}

export function needsCreateProfile(status) {
  const s = getUserStatus(status);
  return s === 9 || s === 0;
}

export function needsDesiredPartner(status) {
  const s = getUserStatus(status);
  return s === 8;
}

